import React, { useState, useEffect } from 'react';
import { Button, Descriptions, Modal, Input } from 'antd';
import { scoutChatCenterServerUrl } from '../../../../autoConfig';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { addMessage } from '../Messages/messageSlice';

export const Header = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const navigate = useNavigate();
  const [dropdownMenu, setDropDown] = useState([
    {
      title: 'Restart'
    },
    {
      title: 'NotificationOff'
    },
    {
      title: 'FullScreen'
    }
  ]);

  const [info, setInfo] = useState([]);
  const { notification } = useSelector((state) => state.widgetState);
  const [role, setRole] = useState('');
  const [name, setName] = useState('');
  const [releaseReason, setReleaseReason] = useState('');
  const [isReleaseModalVisible, setIsReleaseModalVisible] = useState(false);

  const sendMessage = async ({ url, payload }) => {
    try {
      const response = await axios({
        method: 'post',
        url,
        data: payload,
        headers: {
          WebChatApplicationId: '78a7438e-2f83-43e7-8927-8f89e1582761'
        }
      });
      return response;
    } catch (error) {
      console.log('error occurred fetching bot response', error);
      return [];
    }
  };

  const updateDropdownMenu = (index, value) => {
    return dropdownMenu.map((item, idx) => {
      if (idx === index) {
        return {
          ...item,
          title: value
        };
      }
      return item;
    });
  };

  const closeChat = async () => {
    try {
      const response = await axios({
        method: 'post',
        url: `${scoutChatCenterServerUrl}/chat/closeChat/${id}`,
        data: { finishedBy: 'Consultant' }
      });
      navigate('/chat');
      return response;
    } catch (error) {
      console.log('error occurred fetching bot response', error);
      return [];
    }
  };

  const releaseChat = async () => {
    try {
      const response = await axios({
        method: 'post',
        url: `${scoutChatCenterServerUrl}/chat/releaseChat/${id}`,
        data: {
          releaseReason: releaseReason
        }
      });
      sendMessage({
        url: `${scoutChatCenterServerUrl}/chat/messageFromConsultants/${id}`,
        payload: {
          message:
            'We understand that your time is valuable, and we appreciate your patience. We will be with you as soon as possible.'
        }
      });
      setIsReleaseModalVisible(false);
      navigate('/chat');
      return response;
    } catch (error) {
      console.log('error occurred fetching bot response', error);
      return [];
    }
  };

  const authorizedEmails = [
    'vander.deng@travelctm.com',
    'kelly.king@travelctm.com',
    'yuguang.dang@travelctm.com',
    'rony.cheriyan@travelctm.com',
    'chen.he@travelctm.com',
    'samuel.harris@travelctm.com'
  ];

  const isAuthorized = authorizedEmails.includes(name);

  useEffect(() => {
    setDropDown(
      updateDropdownMenu(1, notification ? 'NotificationOff' : 'Notification')
    );
  }, [notification]);

  useEffect(() => {
    setInfo(
      JSON.parse(sessionStorage.getItem('chatList')).filter(
        (item) => item.chatId === id
      )
    );
  }, [id]);

  useEffect(() => {
    localStorage.getItem('username') &&
      setName(JSON.parse(localStorage.getItem('username'))[0].value);
    sessionStorage.getItem('role') && setRole(sessionStorage.getItem('role'));
  }, []);

  useEffect(() => {
    if (
      info[0]?.initialMessage !== undefined &&
      !JSON.parse(sessionStorage.getItem(info[0].chatId))
    ) {
      dispatch(
        addMessage({
          text: info[0]?.initialMessage,
          sender: 'BOT',
          chatId: info[0]?.chatId,
          type: 'text',
          ts: new Date(),
          humanAvatar:
            'https://cdn-assets-cloud.frontify.com/s3/frontify-cloud-files-us/eyJwYXRoIjoiZnJvbnRpZnlcL2FjY291bnRzXC9jZFwvMTk5ODU5XC9wcm9qZWN0c1wvMjY0OTE4XC9hc3NldHNcLzNkXC80NzI1MjU4XC8xYTBhOTZiOGE0NDU0MWFiMzU1MWMxNjUyYTNlYTk4Zi0xNjAwNjU0MzU2LnN2ZyJ9:frontify:gsQ9U0DuxzszjK_ObCuu-MR2AArYhXvQVFRWSvRC5Uc?width=2400'
        })
      );
    }
  }, [info]);

  return (
    <div className="w-full p-2 mb-2">
      <Descriptions
        bordered
        title="Chat Info"
        extra={
          <div>
            <Button
              style={{ marginRight: '8px' }}
              onClick={() => setIsReleaseModalVisible(true)}
            >
              Release
            </Button>
            <Button danger onClick={closeChat}>
              Handled
            </Button>
          </div>
        }
        items={[
          {
            key: '1',
            label: 'Client Name',
            children: info[0]?.clientName
          },
          {
            key: '2',
            label: 'Client Email',
            children: info[0]?.clientEmail
          },
          {
            key: '3',
            label: 'Created Time',
            children: dayjs(info[0]?.createdTime).format('ddd, MMM D, h:mm A')
          },
          {
            key: '4',
            label: 'Client DebtorID',
            children: info[0]?.clientDebtorId
          },
          {
            key: '5',
            label: 'Company Name',
            children: info[0]?.debtorName
          },
          {
            key: '6',
            label: 'Released Reason',
            children: info[0]?.releaseReason
          }
        ]}
      />
      <Modal
        title="Release Reason"
        open={isReleaseModalVisible}
        onOk={releaseChat}
        onCancel={() => setIsReleaseModalVisible(false)}
      >
        <Input
          placeholder="Enter release reason"
          value={releaseReason}
          onChange={(e) => setReleaseReason(e.target.value)}
        />
      </Modal>
    </div>
  );
};
